/** ST-05Ea from L_ST_05Ea_ANALYSE_DUN_MORCEAU; MD-02Ca from L_MD_02Ca_… */
export function formatDocumentCode(code: string | undefined): string | null {
  if (!code) return null;

  let formatted = code.replace(/^[LS]_/, '');
  const match = formatted.match(/^([A-Z]+)_([^_]+)/);
  if (match) return `${match[1]}-${match[2]}`;

  return formatted;
}

export function parseDomainFromCode(code?: string): string {
  if (!code) return 'EX';
  if (code.startsWith('S_')) return 'SONG';
  const match = code.match(/^L_([A-Z]+)_/);
  return match ? match[1] : 'EX';
}

/** Fallback title when DB title is missing */
export function titleFromDocumentCode(code?: string): string {
  if (!code) return 'Document';
  const withoutPrefix = code.replace(/^[LS]_/, '');
  const parts = withoutPrefix.split('_');
  if (parts.length <= 2) return code;
  const slug = parts.slice(2).join(' ');
  if (!slug) return code;
  return slug
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
